import { CapaQuotationDetailedServiceType } from '@generated/graphql';
import Assets from '../Assets';

export default [
  {
    id: 1,
    name: '프레스',
    src: Assets.SheetMetal.PressImage,
    serviceEnum: CapaQuotationDetailedServiceType.Press,
    url:
      'https://capa.ai/blog/posts/%ED%8C%90%EA%B8%88-%EA%B0%80%EA%B3%B5-%EC%89%BD%EA%B3%A0-%EB%B9%A0%EB%A5%B4%EA%B3%A0-%EC%8B%B8%EA%B2%8C-%EC%83%9D%EC%82%B0%ED%95%98%EB%8A%94-%EB%B2%95%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EC%84%B8'
  },
  {
    id: 2,
    name: '레이저 커팅',
    src: Assets.SheetMetal.LaserImage,
    serviceEnum: CapaQuotationDetailedServiceType.LaserCutting,
    url:
      'https://capa.ai/blog/posts/%ED%8C%90%EA%B8%88-%EA%B0%80%EA%B3%B5-%EC%89%BD%EA%B3%A0-%EB%B9%A0%EB%A5%B4%EA%B3%A0-%EC%8B%B8%EA%B2%8C-%EC%83%9D%EC%82%B0%ED%95%98%EB%8A%94-%EB%B2%95%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EC%84%B8'
  },
  {
    id: 3,
    name: '워터젯 커팅',
    src: Assets.SheetMetal.WaterImage,
    serviceEnum: CapaQuotationDetailedServiceType.WaterjetCutting,
    url:
      'https://capa.ai/blog/posts/%ED%8C%90%EA%B8%88-%EA%B0%80%EA%B3%B5-%EC%89%BD%EA%B3%A0-%EB%B9%A0%EB%A5%B4%EA%B3%A0-%EC%8B%B8%EA%B2%8C-%EC%83%9D%EC%82%B0%ED%95%98%EB%8A%94-%EB%B2%95%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EC%84%B8'
  },
  {
    id: 4,
    name: '추천이 필요합니다.',
    src: Assets.SheetMetal.RecommendSheetmetal,
    serviceEnum: CapaQuotationDetailedServiceType.Recommend,
    url:
      'https://capa.ai/blog/posts/%ED%8C%90%EA%B8%88-%EA%B0%80%EA%B3%B5-%EC%89%BD%EA%B3%A0-%EB%B9%A0%EB%A5%B4%EA%B3%A0-%EC%8B%B8%EA%B2%8C-%EC%83%9D%EC%82%B0%ED%95%98%EB%8A%94-%EB%B2%95%EC%9D%84-%EC%95%8C%EC%95%84%EB%B3%B4%EC%84%B8'
  }
];
